import './form-transport-type.scss';

import { TransportTypeFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = TransportTypeFormSchema;
export function FormTransportType() {
  const { control } = useFormContext<TransportTypeFormSchema>();
  return (
    <div id="FormTransportType" className="transport-type">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
    </div>
  );
}

export default FormTransportType;